import React from "react";
import { CircleArrowUp, Lightbulb } from "lucide-react";
import { useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  IconButton,
  Typography,
} from "@mhome/ui";
import { spacingToPx } from "../lib/utils";

const AddOptionDialog = ({ open, onClose, onWidgetSelect, onDeviceSelect }) => {
  const isSmallScreen = useMediaQuery("@media (max-width:599px)");

  const cardOptions = [
    {
      id: "widget",
      title: "Widget Card",
      icon: CircleArrowUp,
      onClick: () => {
        onWidgetSelect();
        onClose();
      },
    },
    {
      id: "device",
      title: "Device Card",
      icon: Lightbulb,
      onClick: () => {
        onDeviceSelect();
        onClose();
      },
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      variant="pops"
      PaperProps={{
        className: isSmallScreen ? "" : "!w-auto",
        style: {
          width: isSmallScreen ? "calc(100% - 32px)" : "auto",
          maxWidth: isSmallScreen ? "calc(100% - 32px)" : "800px",
          minWidth: isSmallScreen ? "auto" : "300px",
          margin: isSmallScreen ? "16px" : "auto",
        },
      }}
    >
      <DialogTitle className="p-2 gap-2 flex items-center min-h-0">
        <IconButton aria-label="close" onClick={onClose} className="shrink-0">
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" component="div" className="leading-tight mb-0">
          Add New Card
        </Typography>
      </DialogTitle>

      <DialogContent className="p-6 rounded-b-2xl overflow-hidden">
        <div
          className={`flex gap-4 justify-center items-stretch ${
            isSmallScreen ? "flex-col" : "flex-row"
          }`}
        >
          {cardOptions.map((option) => {
            const IconComponent = option.icon;
            return (
              <Button
                key={option.id}
                variant="outlined"
                onClick={option.onClick}
                className={`min-h-[100px] p-6 flex flex-col items-center justify-center gap-4 box-border ${
                  isSmallScreen
                    ? "w-full max-w-full flex-none"
                    : "flex-1 w-40 max-w-40"
                }`}
                style={{
                  borderColor: "hsl(var(--border))",
                  backgroundColor: "hsl(var(--card))",
                  color: "hsl(var(--foreground))",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "hsl(var(--accent))";
                  e.currentTarget.style.borderColor = "hsl(var(--primary))";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "hsl(var(--card))";
                  e.currentTarget.style.borderColor = "hsl(var(--border))";
                }}
              >
                <div
                  className="flex items-center justify-center rounded-full"
                  style={{
                    padding: spacingToPx(0.8),
                    backgroundColor: "hsl(var(--primary) / 0.08)",
                  }}
                >
                  <IconComponent
                    size={28}
                    style={{
                      color: "hsl(var(--foreground))",
                    }}
                  />
                </div>
                <Typography
                  variant="body2"
                  align="center"
                  className="font-medium text-[0.95rem]"
                >
                  {option.title}
                </Typography>
              </Button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddOptionDialog;
